<template>
  <div
    class="svc-card"
    @click="openService(
      service.object_detail.slug,
      service.object_detail.id,
      service.object_detail.service_type,
      service.object_detail.name,
      service.object_detail.is_drug_testing,
      service.feature_type,
      service.object_detail.is_service_by_mail,
      service.object_detail.service_type_code,
      service.object_detail.show_capture_method,
      service.object_detail.enable_ori_rate,
      service.object_detail.disable_pii,
      service.object_detail.enable_biometric_data_collection_disclosure,
      service.object_detail.attorney_request
    )"
  >
    <!-- Image / icon -->
    <div class="svc-card__img-wrap">
      <img
        v-if="service.object_detail.image"
        :src="url + service.object_detail.image"
        class="svc-card__img"
        alt=""
      />
      <div class="svc-card__img-placeholder" v-else>
        <i class="fa fa-briefcase"></i>
      </div>
    </div>

    <!-- Text -->
    <div class="svc-card__name">
      {{ service.object_detail.name }}<span class="svc-card__count" v-if="service.feature_type === 'Group' && service.object_detail.service_count"> {{ service.object_detail.service_count }}</span>
    </div>
    <div class="svc-card__desc" v-if="service.object_detail.description">
      {{ service.object_detail.description }}
    </div>

    <!-- Select indicator -->
    <div class="svc-card__footer">
      <span class="svc-card__select">Select <i class="fa fa-chevron-right"></i></span>
    </div>
  </div>
</template>

<script>
import {
  SET_SERVICE_NAME,
  SET_APPOINTMENT_TIME,
  SET_APPOINTMENT_DATE,
  SET_SERVICE_ID,
  SET_SERVICE_TYPE,
  SET_F_SERVICE_SLUG,
  SET_IS_DRUG_TESTING,
  SET_SERVICE_TYPE_CODE,
  SET_IS_SERVICE_BY_MAIL,
  SET_SHOW_CAPTURE_OPTION,
  SET_ENABLE_ORI_RATE,
  SET_SERVICE_DISABLE_PII,
  SET_BIOMETIC_DATA_COLLECTION_DISCLOSURE,
  SET_ATTORNEY_REQUEST,
} from "@/core/services/store/mutations.type";

export default {
  props: {
    url:          { type: String,  default: "" },
    index:        { type: Number,  default: 0 },
    front_status: { type: Boolean, default: true },
    service: {
      type: Object,
      default: () => ({ id: 1, name: "Service Title", image: "", description: "" }),
    },
  },
  methods: {
    openService(
      slug, id, serviceType, name, is_drug_testing, type,
      is_service_by_mail, service_type_code, show_capture_method,
      enable_ori_rate, disable_pii, enable_biometric_data_collection_disclosure,
      attorney_request
    ) {
      if (this.front_status) {
        if (type === "Service") {
          this.$router.push({ name: "frontend.agent.locations", params: { slug, client_slug: this.$route.params.client_slug } });
          this.$store.commit(SET_SERVICE_NAME, name);
          this.$store.commit(SET_SERVICE_ID, id);
          this.$store.commit(SET_APPOINTMENT_TIME, null);
          this.$store.commit(SET_SERVICE_DISABLE_PII, disable_pii);
          this.$store.commit(SET_APPOINTMENT_DATE, "");
          this.$store.commit(SET_SERVICE_TYPE, serviceType);
          this.$store.commit(SET_IS_DRUG_TESTING, is_drug_testing);
          this.$store.commit(SET_SERVICE_TYPE_CODE, service_type_code);
          this.$store.commit(SET_ENABLE_ORI_RATE, enable_ori_rate);
          this.$store.commit(SET_IS_SERVICE_BY_MAIL, is_service_by_mail);
          this.$store.commit(SET_SHOW_CAPTURE_OPTION, show_capture_method);
          this.$store.commit(SET_BIOMETIC_DATA_COLLECTION_DISCLOSURE, enable_biometric_data_collection_disclosure);
          this.$store.commit(SET_ATTORNEY_REQUEST, attorney_request);
          this.$store.commit(SET_F_SERVICE_SLUG, slug);
        } else {
          this.$emit("getGropedService", { id, client_slug: this.$route.params.client_slug });
        }
      } else {
        this.$store.commit(SET_SERVICE_ID, id);
        this.$store.commit(SET_SERVICE_TYPE_CODE, service_type_code);
        this.$emit("setserviceindex", this.index);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$teal:    #5bb8b1;
$dark:    #1a1a2e;
$gray:    #6c7280;
$font:    'Segoe UI', system-ui, sans-serif;

.svc-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  cursor: pointer;
  transition: box-shadow 0.18s, transform 0.15s, border-color 0.18s;
  font-family: $font;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1.5px solid rgba(91, 184, 177, 0.18);
  height: 100%;
  box-sizing: border-box;
  min-width: 0;
  -webkit-tap-highlight-color: transparent;

  @media (min-width: 480px)  { padding: 12px; }
  @media (min-width: 768px)  { padding: 16px; border-radius: 14px; }
  @media (min-width: 1024px) { padding: 20px; border-radius: 16px; }

  &:hover {
    box-shadow: 0 6px 24px rgba(91, 184, 177, 0.28);
    border-color: $teal;
    transform: translateY(-2px);
  }

  &:active { transform: translateY(0); }
}

/* ── Image ── */
.svc-card__img-wrap {
  width: 52px;
  height: 52px;
  border-radius: 10px;
  overflow: hidden;
  background: #ceeae7;
  margin-bottom: 10px;
  flex-shrink: 0;
  border: 1.5px solid rgba(91, 184, 177, 0.25);

  @media (min-width: 480px)  { width: 60px; height: 60px; }
  @media (min-width: 768px)  { width: 72px; height: 72px; margin-bottom: 14px; }
  @media (min-width: 1024px) { width: 80px; height: 80px; margin-bottom: 16px; }
}

.svc-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.svc-card__img-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $teal;
  font-size: 20px;

  @media (min-width: 480px)  { font-size: 24px; }
  @media (min-width: 768px)  { font-size: 28px; }
}

/* ── Name ── */
.svc-card__name {
  font-size: 12px;
  font-weight: 700;
  color: $dark;
  line-height: 1.3;
  margin-bottom: 4px;
  word-break: break-word;

  @media (min-width: 480px)  { font-size: 13px; }
  @media (min-width: 768px)  { font-size: 14px; margin-bottom: 6px; }
  @media (min-width: 1024px) { font-size: 15px; }
}

/* Badge for group service count */
.svc-card__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background: rgba(91, 184, 177, 0.15);
  color: $teal;
  font-size: 10px;
  font-weight: 700;
  vertical-align: middle;
  margin-left: 4px;
}

/* ── Description ── */
.svc-card__desc {
  font-size: 11px;
  color: $gray;
  line-height: 1.45;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;

  @media (min-width: 480px)  { font-size: 12px; -webkit-line-clamp: 3; line-clamp: 3; }
  @media (min-width: 768px)  { font-size: 12px; }
  @media (min-width: 1024px) { font-size: 13px; }
}

/* ── Footer ── */
.svc-card__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(91, 184, 177, 0.15);

  @media (min-width: 768px) { margin-top: 12px; padding-top: 10px; }
}

.svc-card__select {
  font-size: 10px;
  font-weight: 600;
  color: $teal;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
  gap: 3px;

  @media (min-width: 768px) { font-size: 11px; }

  i { font-size: 8px; }
}
</style>
